import { useEffect } from "react";

import {
  GTMContactDetails,
  GTMFormFailedData,
} from "@/types/gtm/ContactDetailsEvent";

export interface ExtendedWindowUserProvider extends Window {
  dataLayer?: GTMContactDetails[];
}

type PageLoadPropsUserProvider = {
  userDetails: GTMContactDetails | null;
  isReady: boolean;
};

// Form Submission options
const useGtmContactDetailsOptions = (props: PageLoadPropsUserProvider) => {
  const { userDetails, isReady } = props;

  useEffect(() => {
    const triggerUserEvent = () => {
      if (userDetails !== null) {
        const extendedWindow = window as ExtendedWindowUserProvider;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        extendedWindow.dataLayer.push({
          ...userDetails,
        });
      }
    };
    if (isReady) {
      triggerUserEvent();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

// Submission failed options
export interface ExtendedWindowFailedSubmission extends Window {
  dataLayer?: GTMFormFailedData[];
}

type PageLoadProps = {
  failedSubmission: GTMFormFailedData | null;
  isReady: boolean;
};

const useGtmContactDetailsFailedOptions = (props: PageLoadProps) => {
  const { failedSubmission, isReady } = props;
  useEffect(() => {
    const triggerSubmissionsFailed = () => {
      if (failedSubmission !== null) {
        const extendedWindow = window as ExtendedWindowFailedSubmission;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        extendedWindow.dataLayer.push({
          ...failedSubmission,
        });
      }
    };
    if (isReady) triggerSubmissionsFailed();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export { useGtmContactDetailsFailedOptions, useGtmContactDetailsOptions };
